export type RiskType = 'risk' | 'issue'
export type RiskSeverityKey = 'unassessed' | 'low' | 'medium' | 'high' | 'critical'

export function parseRiskOwners(value: string) {
  return value.split(',').map((owner) => owner.trim()).filter(Boolean)
}

export function toggleRiskOwner(value: string, owner: string) {
  const owners = parseRiskOwners(value)
  return (owners.includes(owner) ? owners.filter((value) => value !== owner) : [...owners, owner]).join(', ')
}

export function validRiskWorkingItemIds(
  currentIds: string[],
  projectIds: string[],
  workingItems: Array<{ id: string; projectIds: string[] }>,
) {
  if (!projectIds.length) return []
  const allowed = new Set(
    workingItems
      .filter((item) => item.projectIds.some((projectId) => projectIds.includes(projectId)))
      .map((item) => item.id),
  )
  return currentIds.filter((id) => allowed.has(id))
}

export function riskScore(type: RiskType, probability: number | null, impact: number | null) {
  if (!impact) return null
  if (type === 'issue') return 3 * impact
  if (!probability) return null
  return probability * impact
}

export function riskSeverity(type: RiskType, probability: number | null, impact: number | null): {
  key: RiskSeverityKey
  label: string
  score: number | null
  tone: 'gray' | 'blue' | 'yellow' | 'red'
} {
  const score = riskScore(type, probability, impact)
  if (score === null) return { key: 'unassessed', label: '未評估', score, tone: 'gray' }
  if (score <= 2) return { key: 'low', label: '低', score, tone: 'blue' }
  if (score <= 4) return { key: 'medium', label: '中', score, tone: 'yellow' }
  if (score <= 6) return { key: 'high', label: '高', score, tone: 'red' }
  return { key: 'critical', label: '重大', score, tone: 'red' }
}
